import React from 'react';
import { dollarsWithCentsWithSymbol } from 'helpers/currency';
import styled, { css } from 'styled-components';
import { useTripCalculator } from 'hooks/queries';
import { PricingSection, Fees } from './shared';

interface LongPriceSectionProps {
  isModal?: boolean;
}
export default ({ isModal = false }: LongPriceSectionProps) => {
  const { tripCalculation } = useTripCalculator();

  return (
    <LongPriceSectionWrapper isModal={isModal}>
      <PriceList isModal={isModal}>
        <dt className="total">Booking total</dt>
        <dd className="total" data-testid="pdp-booking-widget-booking-total-value">
          {dollarsWithCentsWithSymbol(tripCalculation?.pre_tax_and_fees_booking_total || 0)}
        </dd>
        <FeeNote>Additional fees will show at checkout</FeeNote>
        <hr />
        <dt>Boat price</dt>
        <dd data-testid="pdp-booking-widget-boat-price-value">
          {dollarsWithCentsWithSymbol(tripCalculation?.boat_price)}
        </dd>
        {Boolean(tripCalculation?.captain_fee) && (
          <>
            <DTWithConditionalPadding isPadded={isModal}>Captain price</DTWithConditionalPadding>
            <DDWithConditionalPadding isPadded={isModal} data-testid="pdp-booking-widget-captain-price-value">
              {dollarsWithCentsWithSymbol(tripCalculation?.captain_fee)}
            </DDWithConditionalPadding>
          </>
        )}
      </PriceList>
    </LongPriceSectionWrapper>
  );
};

const LongPriceSectionWrapper = styled(PricingSection)<{ isModal: boolean }>`
  gap: 5px;
  padding-top: 8px;
  ${({ isModal }) =>
    isModal
      ? css`
          margin-bottom: 25px;
          padding-top: 20px;
        `
      : css`
          padding-top: 8px;
        `}
`;

const PriceList = styled.dl<{ isModal: boolean }>`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;

  & dd {
    text-align: end;
  }

  & hr {
    grid-column: 1 / -1;
    width: 100%;
    height: 1px;
    color: rgba(219, 223, 229, 0.5);
    background-color: rgba(219, 223, 229, 0.5);
    margin-top: 12px;
    margin-bottom: 12px;
    border: none;
    ${({ isModal }) =>
      isModal
        ? css`
            margin-top: 15px;
            margin-bottom: 10px;
          `
        : css`
            margin-top: 12px;
            margin-bottom: 12px;
          `}
  }

  & .total {
    font-weight: 600;
  }
`;

const FeeNote = styled(Fees)`
  padding-top: 0;
  grid-column: 1 / -1;
`;

const DTWithConditionalPadding = styled.dt<{ isPadded: boolean }>`
  ${({ isPadded }) =>
    isPadded &&
    css`
      padding-top: 5px;
    `}
`;
const DDWithConditionalPadding = styled.dd<{ isPadded: boolean }>`
  ${({ isPadded }) =>
    isPadded &&
    css`
      padding-top: 5px;
    `}
`;
